module.exports = __webpack_public_path__ + "img/enInvite.60f4764f.png";